import PropTypes from 'prop-types';
import React from 'react';
import { Col, Panel, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add } from '../../../reducers/workOrder/subcontractorTimesheets/subcontractorTimesheets.actions';
import { timesheets } from '../../../reducers/workOrder/subcontractorTimesheets/subcontractorTimesheets.reducer';
import { dirty } from '../../../reducers/workOrder/workOrders.reducer';
import SpinnerButton from '../../SpinnerButton/SpinnerButton';
import ConnectedSubContractorTimesheetForm from './SubContractorTimesheetForm/SubContractorTimesheetForm';
import './SubContractorTimesheets.css';

// eslint-disable-next-line object-curly-newline
export const SubContractorTimesheets = ({ subContractorTimesheets, addSubContractorTimesheet, workOrderId, saveWorkOrder, workOrderDirty, disabled }) => (
  <Panel header="Sub-Contractors" >
    {subContractorTimesheets.map(timesheet => (
      <Row key={timesheet.id} >
        <Col xs={12} >
          <ConnectedSubContractorTimesheetForm subContractor={timesheet} disabled={disabled} />
        </Col>
      </Row>
    ))}
    <Row>
      { !disabled &&
      <Col xs={6} sm={3} >
        <SpinnerButton onClick={() => addSubContractorTimesheet(workOrderId)} >Add Sub-Contractor</SpinnerButton>
      </Col>
      }
      <Col xs={6} sm={2} >
        <SpinnerButton
          onClick={saveWorkOrder}
          bsStyle="primary"
          dirty={workOrderDirty}
          disabled={disabled}
        >
          Save
        </SpinnerButton>
      </Col>
    </Row>
  </Panel>
);

SubContractorTimesheets.propTypes = {
  subContractorTimesheets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  workOrderDirty: PropTypes.bool.isRequired,
  workOrderId: PropTypes.string.isRequired,
  saveWorkOrder: PropTypes.func.isRequired,
  addSubContractorTimesheet: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export const mapStateToProps = (state, ownProps) => ({
  subContractorTimesheets: timesheets(ownProps.workOrderId, state),
  workOrderDirty: dirty(state, ownProps.workOrderId),
});

export const mapDispatchToProps = dispatch => ({
  addSubContractorTimesheet: id => dispatch(add(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubContractorTimesheets);



// WEBPACK FOOTER //
// ./src/components/WorkOrder/SubContractorTimesheets/SubContractorTimesheets.jsx